import { createSlice } from '@reduxjs/toolkit';
import { addNewOrder, editOrder, getAllOrders, getOrderById } from './ordersService';

const initialState = {
  allOrders: {
    isOrdersLoading: null,
    isOrdersSuccess: null,
    ordersMessage: null,
    pageCount: 0,
    orders: [],
  },

  newOrder: {
    isOrderCreating: null,
    isOrderCreated: null,
    orderCreationMsg: null,
  },

  editedOrder: {
    isEditingOrder: null,
    isOrderEdited: null,
    orderEditedMsg: null
  },

  orderDetails: {
    isOrderLoading: null,
    isOrderSuccess: null,
    order: null
  }
};

const ordersSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllOrders.pending, (state) => {
        state.allOrders = {
          ...initialState.allOrders, // Reset to initial state
          isOrdersLoading: true,
          ordersMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllOrders.rejected, (state, action) => {
        state.allOrders = {
          ...initialState.allOrders,
          isOrdersLoading: false,
          isOrdersSuccess: false,
          ordersMessage: action.payload || 'Error occurred while fetching orders',
        };
      })

      // FULFILLED
      .addCase(getAllOrders.fulfilled, (state, action) => {
        state.allOrders = {
          ...initialState.allOrders,
          isOrdersLoading: false,
          isOrdersSuccess: true,
          pageCount: action.payload.pageCount || 0,
          orders: action.payload.data || [],
        };
      });

    //Order creating
    builder
      .addCase(addNewOrder.pending, (state) => {
        state.newOrder = {
          ...initialState.newOrder, // Reset to initial state
          isOrderCreating: true,
          orderCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewOrder.rejected, (state, action) => {
        state.newOrder = {
          ...initialState.newOrder,
          isOrderCreating: false,
          isOrderCreated: false,
          orderCreationMsg: action.payload || 'Error occurred while creating the order.',
        };
      })

      // FULFILLED
      .addCase(addNewOrder.fulfilled, (state, action) => {
        state.newOrder = {
          ...initialState.newOrder,
          isOrderCreating: false,
          isOrderCreated: true,
          orderCreationMsg: action.payload || 'Successfully created the order.',
        };
      });

    //Order editing
    builder
      .addCase(editOrder.pending, (state) => {
        state.editedOrder = {
          ...initialState.editedOrder, 
          isEditingOrder: true,
          orderEditedMsg: 'Loading',
        };
      })

      .addCase(editOrder.rejected, (state, action) => {
        state.editedOrder = {
          ...initialState.editedOrder,
          isEditingOrder: false,
          isOrderEdited: false,
          orderEditedMsg: action.payload || 'Error occurred while editing the order.',
        };
      })

      .addCase(editOrder.fulfilled, (state, action) => {
        state.editedOrder = {
          ...initialState.editedOrder,
          isEditingOrder: false,
          isOrderEdited: true,
          orderEditedMsg: action.payload || 'Successfully edited the order.',
        };
      });

       //Order details
    builder
    .addCase(getOrderById.pending, (state) => {
      state.orderDetails = {
        ...initialState.orderDetails, 
        isOrderLoading: true,
      };
    })

    .addCase(getOrderById.rejected, (state, action) => {
      state.orderDetails = {
        ...initialState.orderDetails,
        isOrderLoading: false,
        isOrderSuccess: false,
      };
    })

    .addCase(getOrderById.fulfilled, (state, action) => {
      state.orderDetails = {
        ...initialState.orderDetails,
        isOrderLoading: false,
        isOrderSuccess: true,
        order: action.payload,
      };
    });
  },
});

export default ordersSlice.reducer;
